(function(w, $) {
    'use strict';

    function checkout(paymentId, $container, controller) {
        var _paymentId = paymentId;
        var _$container = $container;
        var _controller = controller;
        var _klarnaOrderId = null;

        function registerEventListeners() {
            w._klarnaCheckout(function(api) {
                //api.on({ 'load': function (data) {} });
                //api.on({ 'customer': function (data) {} });
                //api.on({ 'change': function(data) {} });
                //api.on({ 'billing_address_change': function(data) {} });
                api.on({ 'shipping_address_change': function (data) { _controller.updateOrder(); } });
                //api.on({ 'can_not_complete_order': function (data) { } });
                //api.on({ 'network_error': function (data) { } });
            });
        }

        return {
            getPaymentId: function () { return _paymentId; },
            getSpecifics: function() {
                return {
                    name: 'Klarna',
                    canDisableDeliveryPostalCode: false
                };
            },
            getOrderFormValues: function () {
                var orderForm = {};
                return orderForm;
            },
            suspendForUpdate: function () {
                // parent control (212) blocks the UI - no need to suspend here
                //if (window._klarnaCheckout) {
                //    window._klarnaCheckout(function(api) {
                //        api.suspend();
                //    });
                //}
            },
            handleUpdatedOrder: function (checkoutOrder) {
                if (_klarnaOrderId === checkoutOrder.KlarnaOrderID) {
                    window._klarnaCheckout(function (api) {
                        api.suspend(); // suspend and resume to make the frame refresh itself
                        api.resume();
                    });
                } else {
                    _$container.empty();
                    _$container.append(checkoutOrder.CheckoutHtmlSnippet);
                    _klarnaOrderId = checkoutOrder.KlarnaOrderID;
                    registerEventListeners();
                }
            }
        };
    }

    if (!w.checkoutProviders) {
        w.checkoutProviders = {};
    }

    w.checkoutProviders.klarnaV3 = checkout;

})(window, jQuery);